import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import styled from 'styled-components'
import userflow from 'userflow.js'

import { colours } from '@qflow/theme'
import { USERFLOW_ID, WELCOME_TO_QFLOW_CHECKLIST_ID } from './userflowId'

export function TakeATour() {
  // Userflow
  const auth = useSelector((state: any) => state.auth)
  const isProduction = window.location.hostname === 'app.qualisflow.com'

  useEffect(() => {
    if (userflow && isProduction) {
      userflow.init(USERFLOW_ID)
      userflow.identify(auth.userUuid ? auth.userUuid : 'anonymous', {
        name: auth.userId ? auth.userId : 'anonymous',
        email: auth.email ? auth.email : 'anonymous'
      })
    }
  }, [auth, isProduction])

  const handleOnClick = () => {
    if (userflow) {
      userflow.start(WELCOME_TO_QFLOW_CHECKLIST_ID)
    }
  }

  if (!isProduction) {
    return null
  }

  return (
    <Container>
      <UserFlowButtonContainer>
        <UserFlowButton id="UserFlowButton" onClick={handleOnClick}>
          Take a tour
        </UserFlowButton>
      </UserFlowButtonContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: initial;
  align-items: center;
`
const UserFlowButtonContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  flex-direction: initial;
  align-items: center;
`
const UserFlowButton = styled.div`
  display: flex;
  align-content: center;
  height: 40px;
  padding: 0 0.75rem;
  border: 1px solid ${colours.CORE_NAVY};
  border-radius: 20px;
  color: ${colours.WHITE};
  background-color: ${colours.CORE_NAVY};
  justify-content: center;
  align-items: center;

  &:hover,
  &:focus {
    color: ${colours.LIGHT_TEAL};
    background-color: ${colours.CORE_NAVY}E6;
    border-color: ${colours.TEAL};
    cursor: pointer;
  }
`
